
import { grey } from '@material-ui/core/colors';

export default (theme) => ({
  container: {
    padding: theme.spacing(1),
    backgroundColor: grey[100],
  },
});
